import { useQuery } from "@tanstack/react-query";
import { ListSubscriptionsQueryFilters, UseListSubscriptionsQueryOptions } from "./types";
import { getSubscriptionsService } from "./service";

export const listSubscriptionsQueryKey = ["subscription_admin"];

export function useListSubscriptionsQuery(
  filters?: ListSubscriptionsQueryFilters,
  options?: UseListSubscriptionsQueryOptions
) {
  const queryKey = listSubscriptionsQueryKey.concat(JSON.stringify(filters));

  return useQuery({
    ...options,
    queryKey,
    queryFn: async () => getSubscriptionsService(filters),
  });
}
